function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "59.835",
  height: "52.344"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_1009",
  "data-name": "Path 1009",
  d: "M21.868 42.871l9.7 6.182 9.7-6.179 5.318 3.388-15.019 9.568-15.017-9.568 5.318-3.388zM19.36 19.2l6.84-4.445-6.934-4.5-7.025 4.338 7.12 4.6zm5.261 3.4l6.837 4.429 6.834-4.429-6.834-4.441-6.836 4.441zm12.1 7.835l6.931 4.483 7.005-4.295-7.106-4.609-6.831 4.416zm-5.263-19.091l12.116-7.858 17.793 10.991-12.558 8.13 12.561 8.149-17.8 10.92-12.109-7.84-12.112 7.834L1.535 30.756 14.1 22.6 1.546 14.477l17.8-10.989 12.115 7.858zm5.253 3.408l6.843 4.448 7.117-4.6-7.023-4.338-6.937 4.5zM26.2 30.433l-6.834-4.421-7.108 4.612 7.008 4.295z",
  transform: "translate(-1.535 -3.486)",
  fill: "#4269a1"
})));